// @ts-nocheck
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_MANAGE_USER = 'SET_MANAGE_USER';
export const SET_MASQUERADE_MODAL_SHOW = 'SET_MASQUERADE_MODAL_SHOW';
export const SET_MASQUERADE_MODAL_SHOW_VIEW = 'SET_MASQUERADE_MODAL_SHOW_VIEW';

export const setMasqueradeModalShow = show => {
  return {
    data: { show },
    type: SET_MASQUERADE_MODAL_SHOW
  };
};
export const setMasqueradeModalShowView = show => {
  return {
    data: { show },
    type: SET_MASQUERADE_MODAL_SHOW_VIEW
  };
};

export const setCurrentUser = user => {
  return {
    data: { user },
    type: SET_CURRENT_USER
  };
};

export const setManageUser = user => {
  return {
    data: { user },
    type: SET_MANAGE_USER
  };
};
